<template>
  <!-- Fallback-состояние «данные не загрузились» (обычно обрыв мобильной сети,
       когда тихие ретраи axios-retry уже исчерпаны): котик + текст + «Повторить».
       Родитель показывает его вместо пустого экрана и ловит @retry. -->
  <v-card-text class="text-center py-10">
    <img :src="catImg" width="140" alt="" />
    <p class="mt-4 mb-6">{{ message || $t("errors.load_failed_network") }}</p>
    <v-btn color="primary" large @click="retry">
      <v-icon left>mdi-refresh</v-icon>
      {{ $t("custom.retry") }}
    </v-btn>
  </v-card-text>
</template>

<script>
import catImageMixin from "@/mixins/catImageMixin";

export default {
  name: "LoadFailedRetry",
  mixins: [catImageMixin],
  props: {
    message: { type: String, default: "" },
  },
  // Компонент намеренно ничего не знает про глобальный индикатор: заявку на
  // «этот отказ объясняю я» делает путь загрузки страницы (store network).
  // Иначе заявку держал бы и скрытый блок, и блок секции внутри рабочей
  // страницы — см. комментарий в store/modules/network.js.
  methods: {
    retry() {
      this.$emit("retry");
    },
  },
};
</script>
